<mat-card class="card-size " [ngClass]="{'disabled-card':disabled}">
  <mat-card-header>
    <mat-card-title>
      <div class="button-card-sovrapossition">
        <ng-content select="[button]">
        </ng-content>
      </div>
      @if (sensorEvent?.name!=null) {
        <div style="margin: 0  210px 0 0;">
          <h3 class="bold">
            {{sensorEvent?.name}}<br>
          </h3>
        </div>
      }
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="h100">
    <div class="margin-text">
      <app-truncate-text [text]="sensorEvent?.note"
        [subTitle]="sensorEvent?.name"
        [maxRows]="3"
        title="{{'SensorEvent.note'|translate}}">

      </app-truncate-text>
      <!--        <span *ngIf="sensorEvent?.note!=null">{{sensorEvent?.note}}</span>-->
    </div>
  </mat-card-content>
  <mat-card-actions style="border-top: 1px solid">
    <!--        <div class="box-footer">-->
    <div class="flex-around-center" style="padding: 10px;width: 200px;max-width: 100%">
      @if ((sensorEvent?.type|transformValueByPredicateFunction:predicateType); as typeIcon) {
        @if (typeIcon.icon) {
          <mat-icon color="primary" [matTooltip]="typeIcon.tooltipText|translate"
          class="icon-size-small_medium">{{typeIcon.icon}}</mat-icon>
        } @else {
          <mat-icon color="primary" [matTooltip]="typeIcon.tooltipText|translate"
            svgIcon="{{typeIcon.svgIcon}}"
          class="icon-size-small_medium"></mat-icon>
        }
      }
      <mat-icon [color]="(sensorEvent?.fired|transformValueByPredicateFunction:predicateBool)"
        [matTooltip]="('SensorEvent.fired'|translate)+': '+(('bool.'+sensorEvent?.fired)|translate)"
        svgIcon="flame"
      class="icon-size-small_medium"></mat-icon>
      <mat-icon [color]="(sensorEvent?.repeatEvent|transformValueByPredicateFunction:predicateBool)"
        [matTooltip]="('SensorEvent.repeatEvent'|translate)+': '+(('bool.'+sensorEvent?.repeatEvent)|translate)"
        class="icon-size-small_medium">repeat
      </mat-icon>
      <button mat-icon-button
        [color]="(sensorEvent?.notification|transformValueByPredicateFunction:predicateNotification)"
        [matTooltip]="('SensorEvent.notificionIsSetted'|translate)+': '+(('bool.'+(sensorEvent?.notification!=null))|translate)"
        (click)="openNotification(sensorEvent)"
        >
        <mat-icon
          class="icon-size-small_medium">mail
        </mat-icon>
      </button>
    </div>
  <!--        </div>-->
</mat-card-actions>

</mat-card>